import styled from 'styled-components';

export const PaginatedTableContainer = styled.div<{
  height?: string;
  minHeight?: number;
  minWidth?: number;
  $borderRadius?: string;
  $horizontalScroll?: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${(props) => props.height && `height: ${props.height};`}
  ${(props) => props.minHeight && `min-height: ${props.minHeight}px;`}
  ${(props) => props.minWidth && `min-width: ${props.minWidth}px;`}
  ${(props) =>
    props.$borderRadius &&
    (props.$horizontalScroll
      ? `
    border-radius: ${props.$borderRadius};
    min-width: 0;
    overflow-x: auto;
    overflow-y: hidden;
  `
      : `
    border-radius: ${props.$borderRadius};
    overflow: hidden;
  `)}
  width: 100%;
`;
